<template>
	<div class="hp-card-wrapper">
		<div class="hp-card">
			<div class="hp-card__head">
				<h2 class="headline-2">{{ title }}</h2>
<!--				<div class="details-data__row">-->
<!--          			<span class="details-badge details-badge&#45;&#45;radio icon-past bg-blue-2 body-2 check">Recent</span>-->
<!--					<span class="details-badge details-badge&#45;&#45;radio icon-fire bg-red body-2">Hot</span>-->
<!--				</div>-->
			</div>
            <div v-if="loading" class="hp-card__loader">
                <LoaderQuad/>
            </div>
			<div v-else class="hp-card__body">
				<HpCardItem
					v-for="item in cards"
					:key="item.id"
					:card="item"
				/>
			</div>
			<div v-if="!loading" class="hp-card__btn-wrapper">
				<div class="hp-card__btn-icon"></div>
			</div>
		</div>
	</div>
</template>

<script>
import HpCardItem from '@/components/main-page/HpCardItem'

export default {
	props: {
		cards: {
			type: Array,
			default: () => []
		},
		title: {
			type: String,
			default: ''
		},
        loading: {
            type: Boolean,
            default: false
        }
	},
}
</script>
